<template>
    <div class="game-description">
        <!--<p class="eyes"-->
           <!--@click="handleEnabled"-->
        <!--&gt;-->
            <!--<span v-if="newEnabled" class="iconfont icon-xianshi"></span>-->
            <!--<span v-else class="iconfont icon-yincang"></span>-->
        <!--</p>-->
        <div class="row">
            <p class="p-box">
                <el-switch
                    v-model="newEnabled"
                    size="small"
                    @change="handleEnabled"
                >
                </el-switch>
                <span class="name">游戏说明:</span>
            </p>
            <el-input
                type="textarea"
                class="input"
                placeholder="请输入游戏说明"
                v-model="newText"
                @input="handleChange"
                @focus="onFocus"
                @blur="onBlur"
            />
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    export default {
        name: "GameDescription",
        props: {
            enabled: Boolean,
            text: String
        },
        watch: {
            enabled(vl){this.newEnabled = vl},
            newEnabled(vl){this.$emit('update:enabled', vl)},
            text(vl){this.newText = vl},
            newText(vl){this.$emit('update:text', vl)},
        },
        data(){
            return {
                newEnabled: this.enabled,
                newText: this.text
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos', 'setOperationQueue']),
            handleEnabled(){
                // this.newEnabled = !this.newEnabled

                this.$emit('onDescription', null, {ObjectKeyValue: {key: 'enabled', value: this.newEnabled}})
            },
            handleChange(){
                this.$emit('onDescription', this.newText)
            },
            onFocus(){
                this.setSendKeyBoardToCocos({key: 'gameDescription', value: false})

                let path = `/question/description/focus`
                let data = true
                const operationQueue = [{path, data, operation: 'REPLACE', oneWay: true}]
                this.setOperationQueue(operationQueue)
            },
            onBlur(){
                this.setSendKeyBoardToCocos({key: 'gameDescription', value: true})

                let path = `/question/description/focus`
                let data = false
                const operationQueue = [{path, data, operation: 'REPLACE', oneWay: true}]
                this.setOperationQueue(operationQueue)
            }
        }
    }
</script>

<style lang="scss" scoped>
.game-description{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    min-width: 100%;

    .eyes{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        background-color: white;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        margin-right: 8px;
        cursor: pointer;

        .icon-yincang{
            font-size: 22px;
            color: #a8aaad;
        }
    }

    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        flex: 1;
        overflow: hidden;

        & /deep/ .el-switch.is-checked .el-switch__core,
        & /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            border-color: #45CB90 !important;
            background-color: #45CB90 !important;
        }

        .p-box{
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: #f5f7fa;
            padding-left: 11px;
            /*margin-right: 8px;*/
            position: relative;

            &:before{
                content: '';
                right: 80px;
                top: 8px;
                position: absolute;
                width: 1px;
                height: 16px;
                background-color: #D8DCE6;
            }
        }

        .name{
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            flex-shrink: 0;
            line-height: 32px;
            background: #F5F7FA;
            border-right: 1px solid #DCDFE6;
            padding: 0px 18px;
            margin-right: 10px;
        }

        & /deep/ .el-input__inner{
            outline: none;
            border: none;
            height: 32px;
            line-height: 32px;
            font-size: 14px;
            font-weight: 400;
            color: #606266;
        }

        .input /deep/ textarea{
            height: 32px;
            line-height: 32px;
            padding-top: 0;
            padding-bottom: 0;
            border: none;
        }
    }
}
</style>
